export const isOutOfTokens = numTokens => numTokens === 0 || numTokens < 0;
